import { Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { CreatedDeviceResponse } from "@/features/devices/hooks";
import { useCopyToClipboard } from "@/hooks/useCopyToClipboard";

interface RevealedDeviceKeyCardProps {
  revealed: CreatedDeviceResponse;
  onClose: () => void;
}

// Reveal one-time da chave do CLP, reposicionado no painel do CLP.
export function RevealedDeviceKeyCard({ revealed, onClose }: RevealedDeviceKeyCardProps) {
  const copy = useCopyToClipboard();
  const copyKey = () => copy(revealed.rawApiKey, "Chave copiada para área de transferência.");
  return (
    <Card className="border-rd-warning-500/30 animate-scale-in bg-rd-warning-50">
      <CardHeader>
        <CardTitle className="text-warning-foreground">
          Guarde a chave agora — ela não será exibida novamente
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-muted-foreground">
          CLP <span className="font-medium">{revealed.device.code}</span> ({revealed.device.name}).
          Configure o CLP com{" "}
          <code className="rounded bg-muted px-1.5 py-0.5 font-mono">username</code> = id do CLP e{" "}
          <code className="rounded bg-muted px-1.5 py-0.5 font-mono">password</code> = esta chave
          (ou header <code className="rounded bg-muted px-1.5 py-0.5 font-mono">X-Device-Key</code>{" "}
          no ingest HTTP).
        </p>
        <div className="flex items-center gap-2 rounded-md border bg-card px-3 py-2 font-mono text-sm">
          <span className="break-all">{revealed.rawApiKey}</span>
          <Button variant="outline" size="sm" onClick={copyKey} aria-label="Copiar chave">
            <Copy className="h-3 w-3" />
            Copiar
          </Button>
        </div>
        <Button variant="ghost" size="sm" onClick={onClose}>
          Já guardei, fechar
        </Button>
      </CardContent>
    </Card>
  );
}
